import React, { useState, useEffect } from 'react';
import { Layout, Menu, Input, Avatar, Dropdown, Button, message } from 'antd';
import { 
  HomeOutlined, 
  FolderOutlined, 
  UserOutlined,
  SearchOutlined,
  LogoutOutlined,
  EditOutlined,
  LoginOutlined
} from '@ant-design/icons';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './index.css';

const { Header } = Layout;

const AppHeader = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentMenu, setCurrentMenu] = useState('home');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 从 localStorage 获取用户信息
    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      setCurrentUser(JSON.parse(userStr));
    }
    
    // 根据当前路径设置菜单高亮
    const path = location.pathname;
    if (path === '/') setCurrentMenu('home');
    else if (path === '/archive') setCurrentMenu('archive');
    else if (path === '/about') setCurrentMenu('about');
    else if (path === '/write') setCurrentMenu('write');
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    setCurrentUser(null);
    message.success('已退出登录');
    navigate('/');
  };

  const handleSearch = () => {
    if (searchText.trim()) {
      navigate(`/?search=${encodeURIComponent(searchText.trim())}`);
    }
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人中心',
      onClick: () => navigate('/about')
    },
    {
      key: 'write',
      icon: <EditOutlined />,
      label: '写文章',
      onClick: () => navigate('/write')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  const menuItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: <Link to="/">首页</Link>,
    },
    {
      key: 'archive',
      icon: <FolderOutlined />,
      label: <Link to="/archive">归档</Link>,
    },
    {
      key: 'about',
      icon: <UserOutlined />,
      label: <Link to="/about">我的</Link>,
    }
  ];

  return (
    <Header className="site-header">
      <div className="header-content">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {/* 左侧Logo和菜单 */}
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Link to="/" className="logo">
              <HomeOutlined className="logo-icon" />
              <span>好奇分享站</span>
            </Link>
            
            <Menu
              className="nav-menu"
              mode="horizontal"
              selectedKeys={[currentMenu]}
              items={menuItems}
              style={{ flex: 1, marginLeft: 32, minWidth: 300, borderBottom: 'none' }}
            />
          </div>

          {/* 右侧搜索和用户信息 */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Input
              className="search-input"
              placeholder="搜索文章..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onPressEnter={handleSearch}
              allowClear
            />
            
            {currentUser ? (
              <>
                <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                  <div className="user-info" style={{ cursor: 'pointer' }}>
                    <Avatar 
                      className="avatar"
                      src={currentUser.avatar} 
                      icon={<UserOutlined />}
                    />
                    <span style={{ marginLeft: 8 }}>{currentUser.name}</span>
                  </div>
                </Dropdown>
                <Button 
                  type="primary" 
                  icon={<EditOutlined />} 
                  style={{ marginLeft: 16 }}
                  onClick={() => navigate('/write')}
                >
                  写文章
                </Button>
              </>
            ) : (
              <Button 
                type="primary" 
                icon={<LoginOutlined />}
                onClick={() => navigate('/auth')}
              >
                登录/注册
              </Button>
            )}
          </div>
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;